import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=6349d615&scoped=true&"
import script from "./StackedBarChart.ts?vue&type=script&lang=ts&"
export * from "./StackedBarChart.ts?vue&type=script&lang=ts&"
import style0 from "./StackedBarChart.scss?vue&type=style&index=0&id=6349d615&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349d615",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VContainer,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
